<script>
import { defineComponent, ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
// import Util from '@/helper/Utility.js';
// import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import Topup2c2pService from '../../service/Topup2c2pService';
//feature
import { useLandingFlow } from '../../feature/LandingFlowFeature';
/**
 * @event onLoaded
 */
export default defineComponent({
    props: {
        apiConfig: { type: String, required: true },
    },
    emits: ['onLoaded', 'onLoaded'],
    setup(props, ctx) {
        const router = useRouter()
        const arrDashboard = ref([])
        let slider = null
        let currentSliderIndex = 0

        const { query, blobWebLanding } = useLandingFlow()

        //#region methods
        const getDashboard = () => {
            var configBuilder = new SubDashboardConfigBuilder()
            var params = configBuilder.create().getParams()
            Topup2c2pService.apiGetSubDashboard(query.value.token, params, props.apiConfig, query.value.appId, blobWebLanding.value, query.value.jwt).subscribe((data) => {
                arrDashboard.value = data
                setSlider()

                ctx.emit('onLoaded')
            }, (err) => {
                ctx.emit('onLoaded')
                console.log(err);
            })
        }
        const clickDashboard = (dashboard) => {
            if (dashboard.type == 'cat') {
                router.push('/topup2c2p/list/' + dashboard.cat)
            } else if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            }
        }
        const setSlider = () => {
            nextTick(() => {
                slider = new Splide('#dashboard-game-slide', {
                    type: 'loop',
                    arrows: false
                }).mount()

                slider.on('move', (newIndex) => {
                    currentSliderIndex = newIndex
                })
            })
        }

        const btnNext = () => {
            let next = currentSliderIndex + 1
            slider.go(next)
        }
        const btnPrev = () => {
            let prev = currentSliderIndex - 1
            slider.go(prev)
        }
        //#endregion methods

        //#region init
        getDashboard()
        //#endregion init

        return {
            arrDashboard,
            clickDashboard,
            btnNext,
            btnPrev,
        }
    }
})
</script>
<template>
    <div>
        <div class="splide" id="dashboard-game-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="k"
                        @click="clickDashboard(dashboard)">
                        <div class="campaign-image" :style="{'background-image': `url('${dashboard.imageUrl}')`}"></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
#dashboard-game-slide {
    .splide__pagination {
        bottom: -20px;
        .splide__pagination__page {
            background: #e5e5e5;
            &.is-active{
                transform: scale(1);
                background: #999999;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 50%);
    }
</style>
